export const home = {
  // Hero Section
  heroSubtitle: '真剣な学習者のための高品質な1対1言語交換',
  heroTitle: 'Maximize the Quality',
  heroTitleHighlight: 'of Language Exchange',
  heroDescription: `EachTeachは、言語交換による会話レッスンと、
会話語彙が蓄積されるWord Poolを組み合わせた、
会話特化型の言語学習サービスです。

レッスンでは、あなたの言語を学習しているネイティブと、
ワークシートに沿って1対1で会話します。

レッスンで実際に使った単語や表現はWord Poolに残り、
会話で本当に使える語彙だけを、効率よく学び続けられます。`,
  getStarted: '今すぐ登録',
  learnMore: 'コースの流れを見る',
  
  // Features
  feature1Title: '安全な有料システム',
  feature1Description: '望まない交流を完全に回避。真剣な学習者だけが集まる環境。',
  feature2Title: '最適なマッチング',
  feature2Description: 'あなたの実力に合わせた学習レベルのパートナーとペアリング。最適な負荷が成長を加速させます。',
  feature3Title: '劇的な効率向上',
  feature3Description: '目標言語で母国語を説明する機会が多く、実践的なスキルが急速に向上。',
  
  // Lesson Content Section
  lessonContentTitle: 'レッスン内容',
  lessonContentSubtitle: '効率的な学習をサポートする充実したレッスン環境',
  
  freeTrial: '初回2回無料',
  freeTrialDescription: 'レッスン前後のアンケートに答えるだけで、最初の2回のレッスンが無料で受講できます！',
  
  googleMeetTitle: 'Google Meetでオンラインレッスン',
  googleMeetDescription: '場所を選ばず、快適な環境でレッスンを受講できます。',
  
  worksheetTitle: '考え抜かれたワークシート',
  worksheetDescription: '会話補助・学習効率の維持を目的に設計されたワークシートに沿ってレッスンを進めます。転用しなければ、書き込んだり印刷したりしてもOK！自分の学習に役立つように使ってください。',
  
  communicationTitle: '本当のコミュニケーション能力',
  communicationDescription: 'レッスン中は翻訳やAI、チャット機能を駆使するなど、コミュニケーションを図る努力が実際の会話で活きることを感じてください。歩み寄るという本当のコミュニケーション能力を伸ばします。',
  
  // Flow Steps
  flowStep1: 'Google Meet\n接続',
  flowStep2: 'ワークシート\nに沿って進行',
  flowStep3: '翻訳・AI活用\nでコミュニケーション',
  flowStep4: '実践的スキル\n向上',
  
  // Pricing Section
  pricingTitle: '料金プラン',
  pricingSubtitle: '学習言語と国籍によって料金が異なります。追加レッスンは通常レッスンの1.2倍の料金です。',
  
  regularLessons: 'レギュラーレッスン（レベルA〜C）',
  englishLearning: '英語学習',
  forJapanese: '日本人向け',
  forKorean: '韓国人向け',
  japaneseKoreanLearning: '日本語/韓国語学習',
  allLearners: 'すべての学習者',
  perLesson: 'レッスンあたり（90分）',
  
  additionalLessons: '追加レッスン（アドバンスコース）',
  englishLearningJapanese: '英語学習（日本人）',
  englishLearningKorean: '英語学習（韓国人）',
  additionalLessonsNote: '追加レッスンはレギュラーレッスン（レベルA〜C）完了後に受講可能です。',
  
  extraLessonsTitle: 'エクストラレッスン（レベル進級）',
  extraLessonsDescription: '各レベルに進級する際、1回のテストと2回の補強レッスンで構成されるエクストラレッスンセットを受講します。料金は通常レッスン3回分相当です。'
};